/* eslint-disable no-undef, no-unused-vars */

/**
 * Bilia tirerate contact form
 *
 * @class TirerateContactForm
 */
class TirerateContactForm {
  constructor() {
    this.form = document.querySelector('.js-tirerate-contact-form');
  }

  /**
   * Create event related actions for contact form
   *
   */
  handleRequiredFields() {
    //prevent form submit if required fields are not filled in
    const submitButton = this.form.querySelector('.tirerate-form-submit');
    const requiredFields = {
      // location: this.form.querySelector('select[name="location"]'),
      // Validated on server side, it's a remultiselect Browser gives error that select field is not focusable.
      name: this.form.querySelector('input[name="name"]'),
      email: this.form.querySelector('input[name="email"]'),
      phone: this.form.querySelector('input[name="phone"]'),
    };

    
    submitButton.addEventListener('click', e => {

      for (const field in requiredFields) {
        requiredFields[field].required = true;
      }

      let fieldsValid = true;
      for (const field in requiredFields) {
        if (!requiredFields[field].checkValidity()) {
          fieldsValid = false;
          break;
        }
      }

      if (!fieldsValid) {
        e.preventDefault();
        window?.grecaptcha?.reset();

      } else {
        window?.onFormSubmit({ 'required': true });
      }

      this.form.requestSubmit();
    });
  }

  init() {
    if(this.form){
      this.handleRequiredFields();
    }
  }
}

export default new TirerateContactForm();
